import { decorate, action, observable } from 'mobx'
import autoBind from "auto-bind"



class OnBoardingStore {
  dialogOpened = false;
  scheduleCallDialogOpened = false;
  isScheduleCallBannerOpened = false;
  isScheduleCallonMenuOpened = false;

  currentActionIndex=-1;

  /**
 * @type { { message: string; state: 'idle' | 'loading' | 'completed' | 'error';, id:string; }[] }
 */
  actions = [];

  constructor() {
    autoBind(this)
  }

  openDialog() {
    this.dialogOpened = true;
  }

  closeDialog() {
    this.dialogOpened = false;
  }

  openScheduleCallDialog() {
    this.scheduleCallDialogOpened = true;
  }

  closeScheduleCallDialog() {
    this.scheduleCallDialogOpened = false;
  }

  openScheduleCallBanner() {
    this.isScheduleCallBannerOpened = true;
  }

  closeScheduleCallBanner() {
    this.isScheduleCallBannerOpened = false;
  }

  openScheduleCallOnMenu() {
    this.isScheduleCallonMenuOpened = true;
  }

  closeScheduleCallOnMenu() {
    this.isScheduleCallonMenuOpened = false;
  }

  addAction(action) {
    this.actions.push(action)
  }

  updateAction(action, i) {
    this.actions[i] = action;
  }

  setActions(actions) {
    this.actions = actions;
  }

  setCurrentActionIndex(index){
    this.currentActionIndex=index
  }
}

decorate(OnBoardingStore, {
  dialogOpened: observable,
  scheduleCallDialogOpened: observable,
  isScheduleCallBannerOpened: observable,
  isScheduleCallonMenuOpened: observable,
  actions: observable,
  currentActionIndex: observable,
  //
  openDialog: action,
  closeDialog: action,
  openScheduleCallDialog: action,
  closeScheduleCallDialog: action,
  openScheduleCallBanner: action,
  closeScheduleCallBanner: action,
  openScheduleCallOnMenu: action,
  closeScheduleCallOnMenu: action,
  //
  addAction: action,
  updateAction: action,
  setActions: action,
  setCurrentActionIndex:action
})

export default OnBoardingStore;